module.exports = __webpack_public_path__ + "static/media/qrimage.7c78dc03.png";